import Model, { JsonArray, JsonObject } from 'src/models/model'

export default class ReportView extends Model {
  static name = 'ReportView'

  static define () {
    this.fields = {
      title: {
        type: String
      },
      layout: {
        type: JsonObject
      },
      viewData: {
        type: JsonArray
      },
      siteData: {
        type: JsonObject
      },
      rawData: {
        type: JsonArray
      },
      multipleElements: {
        type: Boolean
      }
    }
  }
}
